import { useState } from 'react';

export interface EditingState {
  rowIndex: number;
  column: string;
}

export interface CurrencyEditHook {
  editing: EditingState | null;
  onStartEdit: (rowIndex: number, column: string, value: number) => void;
  onChange: (value: string) => void;
  onFinish: () => void;
}

export const useCurrencyEdit = (
  selectedCurrencies: any[],
  setSelectedCurrencies: (currencies: any[]) => void
): CurrencyEditHook => {
  const [editing, setEditing] = useState<{ rowIndex: number | null; column: string | null; value: string }>({
    rowIndex: null,
    column: null,
    value: ''
  });

  const onStartEdit = (rowIndex: number, column: string, rawValue: number) => {
    const decimal = (rawValue / 100).toFixed(2).replace('.', ',');
    setEditing({ rowIndex, column, value: decimal });
  };

  const onChange = (value: string) => {
    setEditing(prev => ({ ...prev, value }));
  };

  const onFinish = () => {
    if (editing.rowIndex === null || editing.column === null) return;

    const updated = [...selectedCurrencies];
    const { rowIndex, column, value } = editing;

    let val = value.replace(',', '.');
    let numericValue = Number(val);
    if (isNaN(numericValue)) numericValue = 0;

    updated[rowIndex] = {
      ...updated[rowIndex],
      [column]: numericValue
    };

    setSelectedCurrencies(updated);
    setEditing({ rowIndex: null, column: null, value: '' });
  };

  return {
    editing:
      editing.rowIndex !== null && editing.column !== null
        ? { rowIndex: editing.rowIndex, column: editing.column }
        : null,
    onStartEdit,
    onChange,
    onFinish
  };
};
